import { __awaiter } from "tslib";
import * as R from "ramda";
import { migrateDidDocumentIfNeeded, updateDidDocumentServices, } from "../lib/did";
export class DidDocumentUpdateContext {
    constructor(wallet, connection, did) {
        this.wallet = wallet;
        this.connection = connection;
        this.did = did;
        this.results = {};
    }
    addUpdateResult(results) {
        this.results = R.mergeDeepRight(this.results, results);
    }
    commit() {
        return __awaiter(this, void 0, void 0, function* () {
            const { connection, wallet, results, did } = this;
            // Determine if there are any did changes
            const didChanges = R.filter((result) => result.didAware !== undefined, results);
            // return null if no did changes to make
            if (R.isEmpty(didChanges)) {
                return null;
            }
            yield migrateDidDocumentIfNeeded(connection, wallet, did);
            // Build list of services from updated ContentResults
            const services = R.map(R.applySpec({
                fragment: R.path(["didAware", "fragmentId"]),
                serviceType: R.always("DataStore"),
                serviceEndpoint: (result) => { var _a; return `${(_a = result.didAware) === null || _a === void 0 ? void 0 : _a.urlPrefix}${result.reference}`; },
            }), R.values(didChanges));
            const transactionId = yield updateDidDocumentServices(connection, wallet, did, services);
            return { transactionId };
        });
    }
}
